angular.module('all', ['ngPatientPortal', 'aprima-legacy-common', 'app', 'rxrefills', 'mychart', 'mymessages', 'aprima-provider-api', 'aprima-core-ui', 'aprima-patient-api', 'aprima-utils', 'myappointments', 'dashboard', 'forms', 'billing', 'account']);

angular.module('all').run([ 'CustomModuleRunService', function(CustomModuleRunService) {
    'use strict';
    CustomModuleRunService.add(
    [ '$rootScope', 'AppRoutes', '_', 'LogOffService', 'TransitionManager', 'Idle', '$uibModalStack', '$log','$state', '$transitions',
    function ($rootScope, AppRoutes, _, LogOffService, TransitionManager, Idle, $modalStack, $log, $state, $transitions) {

        $rootScope.hideToolbar = true;

        $transitions.onStart({}, function onTransitionStart(transition) {
            var toState = transition.targetState() || {};
            var toStateName = toState && toState.name() || '';
            var appRoute = _.find(AppRoutes, {state: toStateName});
            $rootScope.hideToolbar = !!(appRoute && appRoute.portalSettings && appRoute.portalSettings.hideToolbar);
            $rootScope.hideFooter = !!(appRoute && appRoute.portalSettings && appRoute.portalSettings.hideFooter);
            $rootScope.loginView = !!(appRoute && appRoute.state && (appRoute.state === 'login' || appRoute.state === 'statementslogin'));
            if (!$rootScope.loginView){
                $rootScope.$broadcast('IdleStartWatch');
            }
        });
        
        $transitions.onSuccess({}, function updateTitle(transition) {
            var title = transition.injector().get('$title') || 'Patient Portal';
            document.title = title;
        });

        // ng-idle event listeners
        // Please see 'modules\app\app.js' for application timeout configuration and documentation.
        //
        // IdleTimeout - logout logic is implemented here
        $rootScope.$on('IdleTimeout', function() {
            $log.info('Idle timeout has expired.  Logging client out and transitioning to login view.  ' + moment().format('lll'));

            // Has watch() been called and is watching for idleness
            if (Idle.running()) {
                Idle.unwatch();  // stop watching for idleness
            }

            closeOpenModals();

            if($state.current.alternativeLoginRoute){
                // Call log off service and go back to login view
                    LogOffService.logoff().then(function () {
                    TransitionManager.transition({appRoute: AppRoutes.statementslogin.state});
                });
            }
            else {
                // Call log off service and go back to login view
                LogOffService.logoff().then(function () {
                    TransitionManager.transition({appRoute: 'login'});
                });
            }
        });

        function closeOpenModals() {
            // make sure any ui bootstrap modals are closed
            $modalStack.dismissAll();

            // make sure plain bootstrap modals are closed
            angular.element('div.modal.in[role=dialog').removeClass('fade').modal('hide');
        }

        // IdleStartWatch - startup logic is implemented here
        $rootScope.$on('IdleStartWatch', function() {
            Idle.watch();  // start watching for idleness.  $broadcast() is located in LoginCtrl.js
        });
    }]);
}]);
